import {createSelector, sortBy, keyBy} from 'helpers';
import {RootState} from 'store/root-state.type';
import {NoteCategory} from 'types';

export const categories = createSelector(
  (state: RootState) => state.notes.types,
  (types) => [...predefined, ...sortBy(types, 'name')]
);

export const categoriesByName = createSelector(
  categories,
  categories => keyBy(categories, ({name}) => name.trim().toLowerCase())
);

export const categoriesById = createSelector(
  categories,
  categories => keyBy(categories, 'id')
);

export const findCategory = createSelector(
  categoriesByName,
  categoriesByName => (category: string) => categoriesByName[category.trim().toLowerCase()]
);

const predefined: NoteCategory[] = [
  {
    id: 'thank',
    name: 'Thanks',
    predefined: true,
    title: 'Thanks & Gratitude'
  },
  {
    id: 'idea',
    name: 'Ideas',
    predefined: true,
    title: 'New Ideas'
  },
  {
    id: 'question',
    name: 'Questions',
    predefined: true
  },
  {
    id: 'concern',
    name: 'Concerns',
    predefined: true
  },
  {
    id: 'note',
    name: 'Notes',
    predefined: true,
    title: 'Other Notes'
  }
];
